import { DataTable, Heading, Loader } from "@/components";
import useStateLevelTnc from "./useStateLevelTnc";
import { Button, Input, Tabs, TabsList, TabsTrigger } from "@/components/ui";
import { Search } from "lucide-react";
import { tabs } from "./consts";

const StateLevelTnc = () => {
  const {breadcrumbData, onBackClick, globalFilter,
    setGlobalFilter,
    pageNumber,
    setPageNumber,
    pageSize,
    setPageSize,
    sorting,
    setSorting, 
    onAddTemplate, currentTab, onCurrentTabChange,
    isContractLoading, hasAddPermission,
    isRefetchingContract, columns, contractList, onRowClick} = useStateLevelTnc();

    return (
    <div className="p-4 md:p-6">
        {/* Header & Search */}
        <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
          <div className="flex flex-row items-center justify-between">
            <Heading
              title={`State Level TnC Template`}
              breadcrumbData={breadcrumbData}
              showBack
              onBackClick={onBackClick}
            />
          </div>
        </div>

      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
        <Tabs defaultValue="all" className="w-full my-4" value={currentTab}>
          <TabsList className="gap-x-4">
            {tabs?.map((data: any) => (
              <TabsTrigger
                key={data?.value}
                value={data?.value}
                className="hover:cursor-pointer text-gray-400 px-0 border-0 shadow-none data-[state=active]:rounded-none data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:text-black"
                onClick={() => onCurrentTabChange(data.value)}
              >
                {data?.title}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-5 mb-3 md:mb-auto">
        <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {hasAddPermission && <Button onClick={onAddTemplate} className="px-2">
            + Add New Template
          </Button>}
        </div>
      </div>

      {isContractLoading || isRefetchingContract ? 
        <Loader /> : 
        <DataTable
          columns={columns}
          data={(contractList?.data || [])}
          setGlobalFilter={setGlobalFilter}
          globalFilter={globalFilter}
          onRowClick={onRowClick}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          pageNumber={pageNumber}
          pageSize={pageSize}
          totalPages={Math.ceil(contractList?.total / pageSize)}
          totalRecords={contractList?.total}
          serverSidePagination={true}
          sorting={sorting}
          onSortingChange={setSorting}
        />}
    </div>
  );
};

export default StateLevelTnc;